module.exports = __webpack_public_path__ + "static/img/sjfw.b49cab9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/img/sjfw.png
// module id = hmeH
// module chunks = 1